(() => {
  if (customElements.get('video-section')) {
    return;
  }

  class VideoSection extends HTMLElement {
    static PLAYING_CLASS = 'is-playing';

    constructor() {
      super();

      this.playVideo = this.playVideo.bind(this);
      this.pauseVideo = this.pauseVideo.bind(this);
    }

    connectedCallback() {
      this.init();
      this.attachEvents();
    }

    disconnectedCallback() {
      this.detachEvents();
    }

    attachEvents() {
      this.button?.addEventListener('click', this.playVideo);

      this.video?.addEventListener('click', this.pauseVideo);
    }

    detachEvents() {
      this.button?.removeEventListener('click', this.playVideo);

      this.video?.removeEventListener('click', this.pauseVideo);
    }

    init() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('[data-button]');
    }

    playVideo() {
      if (!this.video) {
        return;
      }

      this.video.play();

      this.classList.add(VideoSection.PLAYING_CLASS);
    }

    pauseVideo() {
      if (!this.video) {
        return;
      }

      this.video.pause();

      this.classList.remove(VideoSection.PLAYING_CLASS);
    }
  }

  customElements.define('video-section', VideoSection);
})();
